import { render, staticRenderFns } from "./FeedbackQuestionBlock.vue?vue&type=template&id=5c3e787e&scoped=true"
import script from "./FeedbackQuestionBlock.vue?vue&type=script&lang=ts"
export * from "./FeedbackQuestionBlock.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackQuestionBlock.vue?vue&type=style&index=0&id=5c3e787e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3e787e",
  null
  
)

export default component.exports